var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLike20 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12.8224 4C15.1296 4 17 5.89384 17 8.23001C17 10.464 16.1588 11.5963 12.5648 14.4267L11.0147 15.6475C10.4179 16.1175 9.58213 16.1175 8.98529 15.6475L7.43518 14.4267C3.84115 11.5963 3 10.464 3 8.23001C3 5.89384 4.87039 4 7.17763 4C8.15418 4 9.04672 4.36263 9.83312 5.06036L10 5.21499L10.1669 5.06036C10.9533 4.36263 11.8458 4 12.8224 4Z",
  fill: "currentColor"
})));
export { SvgLike20 as ReactComponent };